import {
  blue5,
  cyan5,
  green5,
  lime5,
  magenta5,
  volcano5,
} from 'css-bit/dist/antd-color.ts';

import 压力指数 from '@xinxiangsui/design-resource/图标/landscape/air-contamination-factory.svg';
import 交感神经指数 from '@xinxiangsui/design-resource/图标/landscape/aquatic-life-corals.svg';
import 专注指数 from '@xinxiangsui/design-resource/图标/landscape/architecture-building-city.svg';
import 协调指数 from '@xinxiangsui/design-resource/图标/landscape/architecture-city-dock.svg';
import 疲劳指数 from '@xinxiangsui/design-resource/图标/landscape/cascade-liquid-moisture.svg';
import 副交感神经指数 from '@xinxiangsui/design-resource/图标/landscape/frozen-glacier-ice-2.svg';
import 体温 from '@xinxiangsui/design-resource/图标/健康指标/旧版/体温.svg';
import 心率 from '@xinxiangsui/design-resource/图标/健康指标/旧版/心率.svg';
import 血压 from '@xinxiangsui/design-resource/图标/健康指标/旧版/血压.svg';
import 血氧 from '@xinxiangsui/design-resource/图标/健康指标/旧版/血氧.svg';

export { blue5 };

export type SensorType =
  | '17'
  | '18'
  | '22'
  | '23'
  | '44'
  | 'resp_rate'
  | 'diastolic'
  | 'systolic'
  | 'hrv_stress'
  | 'hrv_fatigue'
  | 'hrv_coherence'
  | 'hrv_focus'
  | 'hrv_sns'
  | 'hrv_pns';
// | 'score';

export type DataIndex = {
  alias?: string;
  color: string;
  default: number;
  disabled?: boolean;
  extra?: string;
  fake?: boolean;
  full?: string;
  icon?: string;
  index: string;
  indicate: Range;
  label: string;
  precision?: number;
  range: Range;
  unit?: string;
};

export type Range = [number, number];

export type Name = 'systolic' | 'diastolic';

export const dataIndex: Record<SensorType, DataIndex> = {
  // score: {
  //   icon: '',
  //   index: 'score',
  //   label: '如厕指数',
  //   color: blue5,
  //   default: 0,
  //   range: [0, 100],
  //   indicate: [0, 100],
  // },
  17: {
    icon: 心率,
    index: 'heartRate',
    indicate: [20, 220],
    label: '心率',
    precision: 0,
    range: [60, 100],
    default: 75,
    unit: 'bpm',
    color: blue5,
  },
  18: {
    disabled: true,
    extra: '收缩压/舒张压',
    icon: 血压,
    index: 'bloodPressure',
    label: '血压',
    precision: 0,
    unit: 'mmHg',
    indicate: [40, 140],
    default: 70,
    range: [60, 140],
    color: blue5,
  },
  systolic: {
    fake: true,
    icon: 血压,
    index: 'systolic',
    full: '血压/高压',
    label: '收缩压',
    alias: '高压',
    precision: 0,
    unit: 'mmHg',
    indicate: [40, 200],
    default: 110,
    range: [90, 140],
    color: cyan5,
  },
  diastolic: {
    fake: true,
    icon: 血压,
    index: 'diastolic',
    full: '血压/低压',
    label: '舒张压',
    alias: '低压',
    precision: 0,
    unit: 'mmHg',
    indicate: [40, 140],
    default: 70,
    range: [60, 90],
    color: green5,
  },
  22: {
    disabled: true,
    icon: 血氧,
    index: 'spO2',
    label: '血氧',
    precision: 0,
    range: [95, 100],
    indicate: [80, 100],
    default: 97,
    unit: '%',
    color: lime5,
  },
  23: {
    icon: 体温,
    label: '体温',
    index: 'bodyTemperature',
    unit: '°C',
    precision: 1,
    range: [36.1, 37],
    default: 36,
    indicate: [34, 42.9],
    color: volcano5,
  },
  44: {
    icon: 体温,
    index: 'legTemperature',
    indicate: [24, 40],
    label: '腿温',
    precision: 1,
    default: 24,
    range: [28, 36],
    unit: '°C',
    color: volcano5,
  },
  resp_rate: {
    disabled: true,
    icon: 血氧,
    index: 'respRate',
    indicate: [1, 30],
    label: '呼吸率',
    precision: 0,
    default: 12,
    range: [12, 30],
    unit: 'bpm',
    color: magenta5,
  },
  hrv_stress: {
    label: '压力指数',
    index: 'hrv_stress',
    range: [0, 100],
    indicate: [0, 100],
    icon: 压力指数,
    color: blue5,
    default: 0,
  },
  hrv_fatigue: {
    label: '疲劳指数',
    index: 'hrv_fatigue',
    range: [0, 100],
    indicate: [0, 100],
    icon: 疲劳指数,
    color: blue5,
    default: 0,
  },
  hrv_coherence: {
    label: '协调指数',
    index: 'hrv_coherence',
    range: [0, 100],
    indicate: [0, 100],
    icon: 协调指数,
    color: blue5,
    default: 0,
  },
  hrv_focus: {
    label: '专注指数',
    index: 'hrv_focus',
    range: [0, 100],
    indicate: [0, 100],
    icon: 专注指数,
    color: blue5,
    default: 0,
  },
  hrv_sns: {
    label: '交感神经指数',
    index: 'hrv_sns',
    range: [0, 100],
    indicate: [0, 100],
    icon: 交感神经指数,
    color: blue5,
    default: 0,
  },
  hrv_pns: {
    label: '副交感神经指数',
    index: 'hrv_pns',
    range: [0, 100],
    indicate: [0, 100],
    icon: 副交感神经指数,
    color: blue5,
    default: 0,
  },
};

export const sensorTitles: Partial<Record<SensorType, string>> =
  Object.fromEntries(
    Object.entries(dataIndex).map(([key, { label }]) => [key, label]),
  );
